export const PROMOTION_ENABLE_CHANGED_EVENT = 'promotion:enable-changed'

export interface PromotionEnableChangedDetail {
  promotionId: number
  enable: 0 | 1
}

export function dispatchPromotionEnableChanged(detail: PromotionEnableChangedDetail) {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(PROMOTION_ENABLE_CHANGED_EVENT, { detail }))
}

export function onPromotionEnableChanged(
  handler: (detail: PromotionEnableChangedDetail) => void,
): () => void {
  if (typeof window === 'undefined') {
    return () => undefined
  }

  const listener = (event: Event) => {
    handler((event as CustomEvent<PromotionEnableChangedDetail>).detail)
  }

  window.addEventListener(PROMOTION_ENABLE_CHANGED_EVENT, listener)
  return () => window.removeEventListener(PROMOTION_ENABLE_CHANGED_EVENT, listener)
}
